import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 公司自定义全局参数
 */
const companyGlobalParam = {

  /**
   * 增加公司全局参数
   */
  addCompanyGlobalParam (companyId, name, displayName, value, orderNum) {
    return axios.post(base.companyGlobalParam.addCompanyGlobalParam, utils.postParamsArrayToJsonString({ companyId, name, displayName, value, orderNum }))
  },
  /**
   * 修改公司全局参数
   */
  modifyCompanyGlobalParam (companyId, name, displayName, value, orderNum) {
    return axios.post(base.companyGlobalParam.modifyCompanyGlobalParam, utils.postParamsArrayToJsonString({ companyId, name, displayName, value, orderNum }))
  },
  /**
   * 删除公司全局参数
   */
  deleteCompanyGlobalParam (companyId, name) {
    return axios.post(base.companyGlobalParam.deleteCompanyGlobalParam, utils.postParamsArrayToJsonString({ companyId, name }))
  },
  /**
   * 查询公司全局参数
   */
  getCompanyGlobalParams (companyId) {
    return axios.post(base.companyGlobalParam.getCompanyGlobalParams, utils.postParamsArrayToJsonString({ companyId }))
  },
}

export default companyGlobalParam